import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-5" }, "Výber typu zasklenia", -1)
const _hoisted_5 = { class: "list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.types, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              key: t.id,
              class: ""
            }, [
              (t.name !== '')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: t.id != 9 ? `/types/${t.id}` : `/fixies`,
                    class: "font-weight-bold text-uppercase list-group-item list-group-item-action"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}